import { render, staticRenderFns } from "./PublishProject.vue?vue&type=template&id=53756d1a&scoped=true"
import script from "./PublishProject.vue?vue&type=script&lang=js"
export * from "./PublishProject.vue?vue&type=script&lang=js"
import style0 from "./PublishProject.vue?vue&type=style&index=0&id=53756d1a&prod&scoped=true&lang=css"
import style1 from "./PublishProject.vue?vue&type=style&index=1&id=53756d1a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53756d1a",
  null
  
)

export default component.exports